/** 终端模块定义注册 */
import { terminalDefine } from "@api";
import { message } from 'ant-design-vue'

/**
 * 将终端模块定义注册到Vue原型对象
 */
async function prototypeRegister(Vue){
  //获取定义配置
  let res
  try {
    res = await terminalDefine()
	console.log(res)
  } catch (error) { message.error("获取终端模块定义异常！") }
  //转换为对象类型 方便使用
  let define = Object.fromEntries(res.data.map(item => {
    //字段定义列表转换为对象类型 方便使用
    if(item.fieldList) item.field = Object.fromEntries(item.fieldList.map(field => [field.code, field]))
    //页签定义列表转换为对象类型 方便使用
    if(item.tabList) item.tab = Object.fromEntries(item.tabList.map(tab => [tab.code, tab]))
    //页签定义列表转换为对象类型 方便使用
    if(item.btnList) item.btn = Object.fromEntries(item.btnList.map(btn => [btn.code, btn]))
    return [item.moduleCode, item]
  }))
  //将定义配置设置到原型对象
  Vue.prototype.$define = define
  //获取字段定义相关方法
  Vue.prototype.$defineField = (fieldCode, moduleCode) => {
    if (!fieldCode || !moduleCode) return null
    return Vue.prototype.$define?.[moduleCode]?.field?.[fieldCode]
  }
  Vue.prototype.$defineFieldName = (fieldCode, moduleCode) => {
    return Vue.prototype.$defineField(fieldCode, moduleCode)?.fieldName
  }
  //获取页签定义相关方法
  Vue.prototype.$defineTab = (tabCode, moduleCode) => {
    if (!tabCode || !moduleCode) return null
    return Vue.prototype.$define?.[moduleCode]?.tab?.[tabCode]
  }
  Vue.prototype.$defineTabName = (tabCode, moduleCode) => {
    return Vue.prototype.$defineTab(tabCode, moduleCode)?.tabName
  }
  Vue.prototype.$defineTabEnable = (tabCode, moduleCode) => {
    return Vue.prototype.$defineTab(tabCode, moduleCode)?.enable
  }
  //获取按钮定义相关方法
  Vue.prototype.$defineBtn = (fieldCode, moduleCode) => {
    if (!fieldCode || !moduleCode) return null
    return Vue.prototype.$define?.[moduleCode]?.btn?.[fieldCode]
  }
}

//注册自定义指令
function directiveRegister(Vue){
  //按钮 自定义指令
  Vue.directive('btn', {
    inserted: function(el, binding){
      const defineBtn = Vue.prototype.$defineBtn(binding.value, binding.arg)
      if(!defineBtn) return
      //不显示按钮
      if(!defineBtn.enable) {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }
      //修改按钮名称
      //元素不是button 则从下级查找
      if(el.tagName !== 'BUTTON') el = el.querySelector('button')
      //尝试查找下级span 
      let targetDom = el.querySelector('span')
      //没有则为自身
      if(!targetDom) targetDom = el
      targetDom.innerHTML = defineBtn.btnName
    }
  })
  console.log('Vue.prototype', Vue.prototype)
}

export default {
  async install(Vue){
    //将模块定义注册到Vue原型对象
    await prototypeRegister(Vue)
    //注册自定义指令
    directiveRegister(Vue)
  }
}